import Cookies from 'js-cookie'

const TARGET_COOKIE = 'inviteTarget'
const TARGET_EXPIRY_DAYS = 2

export function storeInviteTarget(target: string | undefined) {
    if (!target) return
    Cookies.set(TARGET_COOKIE, target, { expires: TARGET_EXPIRY_DAYS })
    try {
        localStorage.setItem(TARGET_COOKIE, target)
    } catch {
        /* ignore */
    }
}

export function consumeInviteTarget(): string | undefined {
    const fromCookie = Cookies.get(TARGET_COOKIE)
    if (fromCookie) {
        Cookies.remove(TARGET_COOKIE)
        try {
            localStorage.removeItem(TARGET_COOKIE)
        } catch {
            /* ignore */
        }
        return fromCookie
    }
    try {
        const fromLs = localStorage.getItem(TARGET_COOKIE) || undefined
        if (fromLs) localStorage.removeItem(TARGET_COOKIE)
        return fromLs
    } catch {
        return undefined
    }
}
